(() => {
  'use strict';
  const config = window.Voltreya;
  if (!config) return;
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const routeRoot = typeof config.root === 'string' ? config.root : '/';
  const root = routeRoot.endsWith('/') ? routeRoot : routeRoot + '/';
  let currency = config.currency || 'USD';
  const money = cents => new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency }).format(cents / 100);
  const announce = message => { const target = $('[data-ve-announcement]'); if (target) target.textContent = message; };
  const request = async (route, body) => {
    const response = await fetch(root + route, { method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { body: JSON.stringify(body) } : {}) });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Please try again.');
    return data;
  };
  const create = (tag, text, className) => { const element = document.createElement(tag); if (text != null) element.textContent = text; if (className) element.className = className; return element; };
  const drawer = $('[data-bag]');
  const backdrop = $('[data-bag-backdrop]');
  let previousFocus;
  let busy = false;
  const cartError = message => { const element = $('[data-cart-error]'); if (element) { element.textContent = message; element.hidden = !message; } };
  const showDrawer = () => {
    if (!drawer) { location.assign(root + 'cart'); return; }
    if (drawer.hidden) previousFocus = document.activeElement;
    drawer.hidden = false;
    backdrop.hidden = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    $$('[data-ve-background]').forEach(element => { element.inert = true; });
    document.body.classList.add('bag-open');
    $('[data-close-bag]', drawer)?.focus();
  };
  const closeDrawer = () => {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    backdrop.hidden = true;
    $$('[data-ve-background]').forEach(element => { element.inert = false; });
    document.body.classList.remove('bag-open');
    previousFocus?.focus();
  };
  const safeHref = value => { try { const url = new URL(value, location.origin); return url.origin === location.origin ? url.href : root + 'cart'; } catch { return root + 'cart'; } };
  const renderCart = cart => {
    currency = cart.currency || currency;
    $$('[data-bag-count]').forEach(element => { element.textContent = cart.item_count; });
    $$('[data-bag-subtotal]').forEach(element => { element.textContent = money(cart.total_price); });
    $$('[data-cart-checkout]').forEach(element => { element.disabled = !cart.item_count; });
    const container = $('[data-bag-body]');
    if (!container) return;
    container.replaceChildren();
    if (!cart.items.length) { const empty = create('p', 'Your bag is empty. Choose a pack to bring home.', 'empty-bag'); const link = create('a', 'Shop the packs →'); link.href = root + '#shop'; link.addEventListener('click', closeDrawer); empty.append(create('br'), link); container.append(empty); return; }
    cart.items.forEach(item => {
      const row = create('div', null, 'bag-row');
      if (item.image) { const image = create('img'); image.src = item.image; image.alt = item.product_title; image.width = 90; image.height = 90; row.append(image); }
      const details = create('div');
      const link = create('a', item.product_title); link.href = safeHref(item.url); details.append(link);
      if (item.variant_title) details.append(create('span', item.variant_title));
      const controls = create('div', null, 've-line-qty');
      [-1, 1].forEach((delta, index) => {
        const button = create('button', delta < 0 ? '−' : '+'); button.type = 'button'; button.setAttribute('aria-label', (delta < 0 ? 'Decrease' : 'Increase') + ' quantity of ' + item.title); button.disabled = busy;
        button.addEventListener('click', () => changeLine(item.key, Math.max(0, item.quantity + delta)));
        if (index) controls.append(create('span', 'Quantity ' + item.quantity));
        controls.append(button);
      });
      details.append(controls);
      const remove = create('button', 'Remove'); remove.type = 'button'; remove.disabled = busy; remove.setAttribute('aria-label', 'Remove ' + item.title); remove.addEventListener('click', () => changeLine(item.key, 0)); details.append(remove);
      for (const discount of item.line_level_discount_allocations || []) details.append(create('small', discount.discount_application.title));
      row.append(details, create('b', money(item.final_line_price))); container.append(row);
    });
    for (const discount of cart.cart_level_discount_applications || []) container.append(create('p', discount.title + ': −' + money(discount.total_allocated_amount)));
  };
  const changeLine = async (key, quantity) => {
    if (busy) return;
    busy = true; cartError('');
    $$('button', $('[data-bag-body]')).forEach(button => { button.disabled = true; });
    try {
      const cart = await request('cart/change.js', { id: key, quantity });
      busy = false; renderCart(cart); announce('Shopping bag updated. ' + cart.item_count + ' items.');
      if (!drawer.hidden) ($('[data-bag-body] button') || $('[data-close-bag]'))?.focus();
    } catch (error) { cartError(error.message); }
    finally { busy = false; $$('[data-bag-body] button').forEach(button => { button.disabled = false; }); }
  };
  const openCart = async () => {
    showDrawer(); cartError('');
    try { renderCart(await request('cart.js')); } catch { cartError('Your bag could not be loaded. Use “View your bag” below to continue.'); }
  };
  $$('[data-open-bag]').forEach(button => button.addEventListener('click', openCart));
  $$('[data-close-bag]').forEach(button => button.addEventListener('click', closeDrawer));
  backdrop?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', event => {
    if (!drawer || drawer.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); closeDrawer(); }
    if (event.key !== 'Tab') return;
    const focusable = $$('a[href],button:not([disabled]),input:not([disabled]),[tabindex="0"]', drawer).filter(element => element.getClientRects().length);
    const first = focusable[0], last = focusable.at(-1);
    if (event.shiftKey && (document.activeElement === first || document.activeElement === drawer)) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });
  const initialized = new WeakSet();
  const initialize = (scope = document) => {
    $$('[data-product-card]', scope).forEach(card => {
      if (initialized.has(card)) return;
      const data = $('[data-product-json]', card);
      if (!data) return;
      let product;
      try { product = JSON.parse(data.textContent); } catch { return; }
      initialized.add(card);
      const form = $('form', card), select = $('[data-variant-select]', card), input = $('[data-quantity]', card), add = $('[data-add]', card), label = $('[data-add-label]', card), error = $('[data-form-error]', card);
      if (!form || !select || !input || !add) return;
      let variant = product.variants.find(item => String(item.id) === select.value) || product.variants[0];
      let adding = false;
      const quantity = () => {
        const min = Number(input.min) || 1, step = Number(input.step) || 1, max = input.max ? Number(input.max) : 999;
        return Math.max(min, Math.min(max, min + Math.round(((Number(input.value) || min) - min) / step) * step));
      };
      const update = () => {
        const count = quantity(); input.value = count;
        $('[data-current-price]', card).textContent = money(variant.price);
        $('[data-order-total]', card).textContent = money(variant.price * count);
        const packMatch = variant.title.match(/^(\d+)\s*-?\s*pack$/i);
        $('[data-unit-price]', card).textContent = packMatch ? money(variant.price / Number(packMatch[1])) + ' per device' : '';
        add.disabled = !variant.available || adding;
        label.textContent = adding ? 'Adding…' : variant.available ? 'Add to bag' : 'Sold out';
        $$('[data-variant-id]', card).forEach(button => { const active = button.dataset.variantId === String(variant.id); button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); });
        const threshold = Number($('[data-shipping-threshold]', card)?.dataset.shippingThreshold);
        if (threshold) {
          const total = variant.price * count;
          $('[data-ship-meter]', card).style.width = Math.min(100, total / threshold * 100) + '%';
          $('[data-shipping-left]', card).textContent = total >= threshold ? 'This selection meets the free shipping minimum before discounts. Eligible contiguous US orders only.' : money(threshold - total) + ' away from the free shipping minimum with this selection.';
        }
      };
      const selectVariant = id => {
        const next = product.variants.find(item => String(item.id) === String(id));
        if (!next) return;
        variant = next; select.value = String(id);
        const rule = next.quantity_rule || { min: 1, increment: 1 };
        input.min = rule.min || 1; input.step = rule.increment || 1; input.max = rule.max || ''; error.hidden = true;
        if (document.body.classList.contains('page-product')) { const url = new URL(location.href); url.searchParams.set('variant', id); history.replaceState({}, '', url); }
        update();
      };
      $$('[data-variant-id]', card).forEach(button => button.addEventListener('click', () => selectVariant(button.dataset.variantId)));
      select.addEventListener('change', () => selectVariant(select.value));
      $('[data-quantity-minus]', card)?.addEventListener('click', () => { input.value = quantity() - (Number(input.step) || 1); update(); });
      $('[data-quantity-plus]', card)?.addEventListener('click', () => { input.value = quantity() + (Number(input.step) || 1); update(); });
      input.addEventListener('change', update);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (adding || !variant.available || !form.reportValidity()) return;
        adding = true; error.hidden = true; update();
        try {
          const payload = new FormData(form);
          const response = await fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: payload });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'This pack could not be added. Please try again.');
          announce('Added ' + quantity() + ' ' + variant.title + ' to your bag.');
          await openCart();
        } catch (problem) { error.textContent = problem.message; error.hidden = false; }
        finally { adding = false; update(); }
      });
      card.classList.add('ve-ready'); update();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  const menuButton = $('[data-menu-button]'), menu = $('[data-menu]');
  menuButton?.addEventListener('click', () => { const open = menu?.classList.toggle('is-open'); menuButton.setAttribute('aria-expanded', String(Boolean(open))); });
  $$('[data-menu] a').forEach(link => link.addEventListener('click', () => { menu?.classList.remove('is-open'); menuButton?.setAttribute('aria-expanded', 'false'); }));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') { menu?.classList.remove('is-open'); menuButton?.setAttribute('aria-expanded', 'false'); } });
  window.addEventListener('pageshow', event => { if (event.persisted) request('cart.js').then(renderCart).catch(() => {}); });
})();
